export default "__VITE_ASSET__$L0QvCli__"